<template>
    <v-container id="login" class="fill-height">
        <v-row justify="center">
            <v-slide-y-transition appear>
                <base-material-card
                    color="primary"
                    light
                    class="login_base-material-card_portrait">
                    <template v-slot:heading>
                        <div class="text-center">
                            <h1 class="display-2 font-weight-bold mb-2">
                                SC<sup>2</sup> - SunFlight - Login
                            </h1>
                            <v-tooltip v-for="(social, i) in socials" :key="i" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="ma-1"
                                        style="height:2.9rem;width:2.7rem;"
                                        icon
                                        rel="noopener"
                                        target="_blank"
                                        :alt="socials.alt"
                                        v-bind="attrs"
                                        :href="social.href"
                                        v-on="on">
                                        <v-icon :disabled="social.disabled" v-text="social.icon" />
                                    </v-btn>
                                </template>
                                <span>{{ social.tooltiptxt }}</span>
                            </v-tooltip>
                        </div>
                    </template>

                    <v-card-text class="text-center">
                        <div
                            class="text-center grey--text font-weight-light">
                            'Discover the World'
                        </div>

                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                            autocomplete="off"
                            :class="{ 'login_v-form_landscape': !$isScreenPortrait() }">
                            <v-text-field
                                v-model="username"
                                :class="{ 'login_v-text-field': $isScreenPortrait() }"
                                :rules="[rules.required, rules.min]"
                                label="User Name.."
                                hint="At least 3 characters"
                                prepend-icon="mdi-face"
                                color="secondary" />

                            <v-text-field
                                v-model="password"
                                :class="{ 'login_v-text-field': $isScreenPortrait() }"
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="show1 ? 'text' : 'password'"
                                label="Password.."
                                hint="At least 3 characters"
                                prepend-icon="mdi-lock-outline"
                                counter
                                color="secondary"
                                @click:append="show1 = !show1" />

                            <pages-btn
                                color="primary"
                                :class="{
                                    'login_pages-btn_portrait': $isScreenPortrait(),
                                    'login_pages-btn_landscape': !$isScreenPortrait(),
                                    'v-btn--text': true
                                }"
                                width="50%"
                                :rounded="false"
                                :disabled="!valid"
                                style="color: #ffffff;"
                                @click="onValidate">
                                Let's Go
                            </pages-btn>
                        </v-form>
                    </v-card-text>
                </base-material-card>
            </v-slide-y-transition>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import {
        CONF_ENVIRONMENT,
        CONF_CLIENT_URLS_SC2_CREWPLANNING2_PROD,
        CONF_CLIENT_URLS_SC2_CREWPLANNING2_TEST,
        CONF_CLIENT_URLS_SC2_FLIGHTS_PROD,
        CONF_CLIENT_URLS_SC2_FLIGHTS_TEST,
        CONF_CLIENT_URLS_SC2_PEOPLE_PROD,
        CONF_CLIENT_URLS_SC2_PEOPLE_TEST,
        CONF_CLIENT_URLS_SC2_HOTELS_PROD,
        CONF_CLIENT_URLS_SC2_HOTELS_TEST,
        CONF_CLIENT_URLS_SC2_VACATION_PROD,
        CONF_CLIENT_URLS_SC2_VACATION_TEST,
        CONF_CLIENT_URLS_SC2_REPORTS_PROD,
        CONF_CLIENT_URLS_SC2_REPORTS_TEST,
        CONF_CLIENT_URLS_SC2_TIMESTATS_PROD,
        CONF_CLIENT_URLS_SC2_TIMESTATS_TEST,
        CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_PROD,
        CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_TEST,
        CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_PROD,
        CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_TEST,
        CONF_CLIENT_URLS_SC2_TRAININGS_PROD,
        CONF_CLIENT_URLS_SC2_TRAININGS_TEST,
        CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD,
        CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST
    } from '../../config';


    export default {
        name: 'PagesLogin',

        /* >>> *************************************************************** / /* Components */
        components: {

            PagesBtn: () => import('./components/Btn')

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            valid: false,
            username: '',
            password: '',
            show1: false,
            // >>> ------------------------------
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 3 || 'Min 3 characters',
                emailMatch: () => ('The email and password you entered don\'t match')
            },
            // >>> ------------------------------
            socials: [
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_PEOPLE_PROD : CONF_CLIENT_URLS_SC2_PEOPLE_TEST,
                    icon: 'mdi-account-multiple', // people
                    tooltiptxt: 'People',
                    disabled: true

                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_HOTELS_PROD : CONF_CLIENT_URLS_SC2_HOTELS_TEST,
                    icon: 'mdi-bed', // hotels
                    tooltiptxt: 'Hotels',
                    disabled: true
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_VACATION_PROD : CONF_CLIENT_URLS_SC2_VACATION_TEST,
                    icon: 'mdi-beach', // vacations
                    tooltiptxt: 'Vacations',
                    disabled: true
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_REPORTS_PROD : CONF_CLIENT_URLS_SC2_REPORTS_TEST,
                    icon: 'mdi-briefcase-download', // reports
                    tooltiptxt: 'Reports',
                    disabled: true
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_TIMESTATS_PROD : CONF_CLIENT_URLS_SC2_TIMESTATS_TEST,
                    icon: 'mdi-av-timer', // timestats
                    tooltiptxt: 'TimeStats',
                    disabled: true
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_PROD : CONF_CLIENT_URLS_SC2_AIRPORTQUALIFICATIONS_TEST,
                    icon: 'mdi-airport', // airportqualifications
                    tooltiptxt: 'AirportQualifications',
                    disabled: true
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_PROD : CONF_CLIENT_URLS_SC2_CONFIRMATIONOVERVIEW_TEST,
                    icon: 'mdi-account-check', // confirmationoverview
                    tooltiptxt: 'ConfirmationOverview',
                    disabled: true
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_TRAININGS_PROD : CONF_CLIENT_URLS_SC2_TRAININGS_TEST,
                    icon: 'mdi-account-school', // trainings
                    tooltiptxt: 'Trainings&Checks',
                    disabled: true
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_DUTYPLAN_PROD : CONF_CLIENT_URLS_SC2_DUTYPLAN_TEST,
                    icon: 'mdi-book-account', // dutyplan
                    tooltiptxt: 'Dutyplan',
                    disabled: true
                },



                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_FLIGHTS_PROD : CONF_CLIENT_URLS_SC2_FLIGHTS_TEST,
                    icon: 'mdi-airplane-takeoff', // flights
                    tooltiptxt: 'SunFlight',
                    disabled: false
                },
                {
                    href: CONF_ENVIRONMENT === 'PROD' ? CONF_CLIENT_URLS_SC2_CREWPLANNING2_PROD : CONF_CLIENT_URLS_SC2_CREWPLANNING2_TEST,
                    icon: 'mdi-account-switch', // crewplanning2
                    tooltiptxt: 'Crewplannning2',
                    disabled: true
                }
            ]

        }), // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getIdUser' // This is tmp only
            ])

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
		created: function () {

            const me = this;


            me.$toc('>>> views/pages/Login.vue >>> created');

		}, // eof created()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_userLogin'
            ]),


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate()
            *
            * Desc: Check if Form is valid. If so ... Login.
            * Note:
            *
            */
            onValidate: function() {

                const me = this;


                me.$toc('>>> views/pages/Login.vue >>> onValidate');
                if (this.$refs.form.validate()) {
                    const params = {
                        username: this.username,
                        password: this.password
                    };
                    this.actn_userLogin(params);
                }

            }, // eof onValidate()


            /*******************************************************************
            * reset()
            *
            * Desc: Reset Form.
            * Note: Still unused.
            *
            */
            reset: function() {

                this.$refs.form.reset();

            }, // eof reset()


            /*******************************************************************
            * resetValidation()
            *
            * Desc: Reset Forms Validations.
            * Note: Still unused.
            *
            */
            resetValidation: function() {

                this.$refs.form.resetValidation();

            } // eof resetValidation()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style>
    input:-webkit-autofill {
        -webkit-box-shadow: 0 0 0px 1000px #fff inset;
        -moz-box-shadow: 0 0 0 100px #fff inset;
        box-shadow: 0 0 0 100px #fff inset;
        /* change the white to any color */
    }

    .v-application .ma-1 {
        margin: 1px !important;
    }
</style>

<style scoped>
    .login_base-material-card_portrait {
        padding: 0.85rem 1.42rem !important;
        width: 80% !important;
        max-width: 465px;
    }
    .login_v-text-field {
        margin-top: 2.85rem !important;
    }
    /* .login_v-form_landscape {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: .5rem 0 !important;
    } */
    .login_pages-btn_portrait {
        width: 50%;
        margin-top: 2.14rem;
        margin-bottom: 1.42rem;
    }
    .login_pages-btn_landscape {
        width: 1rem !important;
        margin: 0 2rem !important;
    }
</style>
